module.exports = __webpack_public_path__ + "assets/img/gongnue.e103a5bf.png";